import React from "react";
import { getBEMClasses } from "../helpers/cssClassesHelper";
import StandAloneLayout from "../layouts/StandAloneLayout/StandAloneLayout";

import "../styles/components/common/StandaloneForm.css";

const baseClasses = getBEMClasses("standalone-form");

export const MaintenancePage = () => {
  return (
    <StandAloneLayout>
      <div className={`${baseClasses("container")}`} style={{ textAlign: "center", padding: "50px" }}>
        <h1>Maintenance Mode</h1>
        <p>We are currently under maintenance. Please try again later.</p>
      </div>
    </StandAloneLayout>
  );
};

export default MaintenancePage;